import { SET_MEDICINES, REMOVE_MEDICINES, FILTER_MEDICINES } from './types'

const medicines = (state = {
  data: [],
  targetDiseases: null
}, action) => {
  switch (action.type) {
    case SET_MEDICINES:
      return Object.assign({}, state, {data: action.payload})
    case FILTER_MEDICINES:
      return Object.assign({}, state, {targetDiseases: action.payload.targetDiseases,
        data: action.payload.data
      })
    case REMOVE_MEDICINES:
      return {}
    default:
      return state
  }
}

export default medicines
